import React from "react";
import { FetchFunction } from "../FetchProvider";
import { defineMessages } from "react-intl";
import UserSessionDialog from "./UserSessionDialog";
import UserServiceSessionDialog from "../UserServiceSessionDialog";
import NotSetValue from "../NotSetValue";

export const labelTranslations = defineMessages({
    unknown: { id: "user_session.unknown", defaultMessage: "unknown" },
    type: { id: "user_session.type", defaultMessage: "Type" },
    device: { id: "user_session.device", defaultMessage: "Device" },
    os: { id: "user_session.os", defaultMessage: "Operating system" },
    client: { id: "user_session.client", defaultMessage: "Client" },
    last_use: { id: "user_session.last_use", defaultMessage: "Last used" },
    apps: { id: "user_session.apps", defaultMessage: "Applications" },
    active: { id: "user_session.active", defaultMessage: "This session" },
    location: { id: "user_session.location", defaultMessage: "Location" },
    created: { id: "user_session.created", defaultMessage: "First used" },
    createdService: { id: "user_session.createdService", defaultMessage: "Created" },
    delete: { id: "user_session.delete", defaultMessage: "Delete this session" },
    dialog_title: { id: "user_session.dialog_title", defaultMessage: "Session details:" },
    dialog_title_service: { id: "user_session.dialog_title_service", defaultMessage: "Service session for" },
    never: { id: "user_session.never", defaultMessage: "never" },
    internal: { id: "user_session.internal", defaultMessage: "internal" },
    private: { id: "user_session.private", defaultMessage: "private" },
    service: { id: "user_session.service", defaultMessage: "Service" },
    just_now: { id: "user_session.just_now", defaultMessage: "just now" },
    empty_list: { id: "user_session.empty_list", defaultMessage: "There are no sessions!" },
    access_token: { id: "user_session.access_token", defaultMessage: "Access token" },
    refresh_token: { id: "user_session.refresh_token", defaultMessage: "Refresh token" },
    name: { id: "user_session.name", defaultMessage: "Name" },
    identifier: { id: "user_session.identifier", defaultMessage: "Identifier" },
    app_identifier: { id: "user_session.app_identifier", defaultMessage: "OAuth Client ID" },
    app: { id: "user_session.app", defaultMessage: "Application" },
    ip: { id: "user_session.ip", defaultMessage: "IP" },
})


export type UserSessionListState = {
    sessionDialogData: any;
    rows: Array<any>;
    showDialog: boolean;
};

export const fetchData = async (userSub: string, fetch: FetchFunction): Promise<Array<any>> => {
    let url = "/api/sessions";
    if (userSub) url += "?user_sub=" + userSub;
    const response = await fetch(url);
    if (response.status !== 200) {
        window.location.reload();
        return;
    }

    return await response.json();
};

export const deleteSelectedSessions = (sessions: Array<any>, fetch: FetchFunction) =>
    fetch("/api/delete-sessions", {
        method: "post",
        body: JSON.stringify(sessions),
        headers: {
            "Content-Type": "application/json",
        },
    });

export const UserSessionListDialog: React.FC<{
    open: boolean;
    data: any;
    hide: () => void;
    deleteSelectedSessions: () => void;
    disableDeleteCurrentSession: boolean;
}> = ({ open, data, hide, deleteSelectedSessions, disableDeleteCurrentSession }) => {
    if (!data) return null;

    const session = data;

    const DialogRenderer = session["type"] === "service" ? UserServiceSessionDialog : UserSessionDialog;

    return (
        <DialogRenderer
            session={session}
            show={open}
            onHide={hide}
            onDelete={deleteSelectedSessions}
            disableDeleteCurrentSession={disableDeleteCurrentSession}
        />
    );
};

export const RenderUserSessionList = ({
    Dialog,
    List,
    rowsLength,
    userSub,
}: {
    Dialog: React.ComponentType<any>;
    List: React.ComponentType<any>;
    rowsLength: number;
    userSub: string;
}) => {
    if (rowsLength === 0 && userSub) {
        return <NotSetValue label={labelTranslations.empty_list} />;
    }

    return (
        <div>
            <Dialog />
            <List />
        </div>
    );
};
